// import Company from './Company';

const sagas = {
  // Company,
};

export default function sagaInitiator(sagaMiddleware: any) {
  Object.values(sagas).forEach((saga) => {
    sagaMiddleware.run(saga);
  });
}
